import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
import { environment } from "environments/environment";


export function loggerCallback(logLevel: LogLevel, message: string) {
    console.log(message);
}

let msalInstance: IPublicClientApplication | null = null;
let initPromise: Promise<void> | null = null;

export default function MSALInstanceFactory(): IPublicClientApplication {
    if (msalInstance) {
        return msalInstance;
    }

    const pca = new PublicClientApplication({
        auth: {
            clientId: environment.msalConfig.auth.clientId,
            authority: environment.msalConfig.auth.authority,
            redirectUri: environment.msalConfig.auth.redirectUri || '/',
            postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri || '/',
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Warning,
                piiLoggingEnabled: false,
            },
        },
    });

    // Asegurar que initialize() sea idempotente y comparta la misma promesa si se llama concurrentemente
    const originalInitialize = pca.initialize.bind(pca);
    pca.initialize = () => {
        if (!initPromise) {
            initPromise = originalInitialize().catch((err) => {
                initPromise = null;
                throw err;
            });
        }
        return initPromise;
    };

    msalInstance = pca;
    return pca;
}